import { render, staticRenderFns } from "./rewardsList.vue?vue&type=template&id=25b8e98d"
import script from "./rewardsList.vue?vue&type=script&lang=js"
export * from "./rewardsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports